import React, { useState, useEffect } from "react";
import "./IntegrationModals.css";
import { FaEnvelope } from "react-icons/fa";
import { api } from "../../../services/api";
import { toast } from "react-toastify";

const Email = ({
  isOpen,
  onClose,
  providerKey,
  integrationId,
  env = "production",
  onSave,
  credentials,
  showLabel = false,
  initialLabel = ""
}) => {

  const [form, setForm] = useState({
    host: "",
    port: 587,
    username: "",
    password: "",
    use_tls: true,
    use_ssl: false,
    sender_name: "",
  });
  const [label, setLabel] = useState(initialLabel);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    if (credentials && credentials.summary && credentials.summary.host) {
      setForm({
        host: credentials.summary.host || "",
        port: credentials.summary.port || 587,
        username: credentials.summary.username || "",
        password: "",
        use_tls:
          typeof credentials.summary.use_tls === "boolean"
            ? credentials.summary.use_tls
            : true,
        use_ssl:
          typeof credentials.summary.use_ssl === "boolean"
            ? credentials.summary.use_ssl
            : false,
        sender_name: credentials.summary.sender_name || "",
      });
    } else {
      setForm({
        host: "",
        port: 587,
        username: "",
        password: "",
        use_tls: true,
        use_ssl: false,
        sender_name: "",
      });
    }
  }, [isOpen, integrationId, providerKey, credentials]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "port") {
      setForm((prev) => ({
        ...prev,
        port: Number(value) || 0,
      }));
      return;
    }

    if (name === "use_tls" || name === "use_ssl") {
      setForm((prev) => ({
        ...prev,
        [name]: value === "true",
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let finalIntegrationId = integrationId;
      let isNewIntegration = false;

      if (!finalIntegrationId) {
        const connectRes = await api.post(
          `/api/integrations/${providerKey}/connect`,
          { env }
        );
        const connectData = connectRes.data;
        finalIntegrationId = connectData.id;
        isNewIntegration = true;
      }


      const credentialsPayload = {
        host: form.host,
        port: Number(form.port) || 587,
        username: form.username,
        use_tls: form.use_tls,
        use_ssl: form.use_ssl,
        sender_name: form.sender_name || null,
      };

      if (form.password) {
        credentialsPayload.password = form.password;
      }

      const payload = {
        credentials: credentialsPayload,
      };

      const credRes = await api.put(
        `/api/integrations/${finalIntegrationId}`,
        payload
      );

      const updatedIntegration = credRes.data;
      if (isNewIntegration) {
        toast.success("Credenciais de Email cadastradas com sucesso!");
      } else {
        toast.success("Credenciais de Email atualizadas com sucesso!");
      }

      if (typeof onSave === "function") {
        onSave(providerKey, updatedIntegration);
      }

      onClose();
    } catch (error) {
      let errorMessage = "Erro ao salvar credenciais de Email";

      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = `Erro: ${error.message}`;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="int-modal-backdrop" onClick={onClose}>
      <div className="int-modal" onClick={(e) => e.stopPropagation()}>
        <div className="int-modal-header">
          <div className="int-modal-title-wrap">
            <FaEnvelope className="int-channel-icon" />
            <div>
              <h3>Configuração de Email (SMTP)</h3>
              <p>Configure aqui as credenciais de envio de e-mail do FASTTEAM.</p>
            </div>
          </div>
          <button
            type="button"
            className="int-modal-close"
            onClick={onClose}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="int-modal-body">
            <p className="int-modal-description">
              Informe os dados do servidor SMTP. Eles serão usados para disparos de
              e-mail pelas automações e notificações da plataforma.
            </p>

            <div className="int-modal-form">
              {showLabel && (
                <div className="int-form-group">
                  <label htmlFor="integration_label">Nome da Integração *</label>
                  <input
                    id="integration_label"
                    name="integration_label"
                    type="text"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    placeholder="Ex: Gmail Vendas"
                    required={showLabel}
                  />
                </div>
              )}
              <div className="int-form-group">
                <label htmlFor="host">Mail Server (Host) *</label>
                <input
                  id="host"
                  name="host"
                  type="text"
                  value={form.host}
                  onChange={handleChange}
                  placeholder="Ex: smtp.gmail.com"
                  required
                />
              </div>

              <div className="int-form-group">
                <label htmlFor="port">Porta *</label>
                <input
                  id="port"
                  name="port"
                  type="number"
                  value={form.port}
                  onChange={handleChange}
                  placeholder="Ex: 587 ou 465"
                  required
                />
              </div>

              <div className="int-form-group">
                <label htmlFor="use_tls">Usar TLS *</label>
                <select
                  id="use_tls"
                  name="use_tls"
                  value={form.use_tls ? "true" : "false"}
                  onChange={handleChange}
                  required
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>

              <div className="int-form-group">
                <label htmlFor="use_ssl">Usar SSL *</label>
                <select
                  id="use_ssl"
                  name="use_ssl"
                  value={form.use_ssl ? "true" : "false"}
                  onChange={handleChange}
                  required
                >
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className="int-form-group">
                <label htmlFor="username">Usuário (login) *</label>
                <input
                  id="username"
                  name="username"
                  type="email"
                  value={form.username}
                  onChange={handleChange}
                  placeholder="Seu usuário de e-mail / SMTP"
                  required
                />
              </div>

              <div className="int-form-group">
                <label htmlFor="password">Senha / App Password *</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Senha do SMTP ou App Password"
                  required={!integrationId}
                />
              </div>

              <div className="int-form-group">
                <label htmlFor="sender_name">
                  Nome do remetente (opcional)
                </label>
                <input
                  id="sender_name"
                  name="sender_name"
                  type="text"
                  value={form.sender_name}
                  onChange={handleChange}
                  placeholder="Ex: Equipe FASTTEAM"
                />
              </div>
            </div>
          </div>

          <div className="int-modal-footer">
            <button
              type="button"
              className="int-btn-outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="int-btn-primary"
              disabled={loading}
            >
              {loading
                ? "Salvando..."
                : integrationId
                  ? "Salvar alterações"
                  : "Conectar canal"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Email;
